var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HorizontalCarousel',{attrs:{"items":_vm.items,"options":_vm.options},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('CourseThumbBox',{staticClass:"course-thumb-box",attrs:{"course":item}},[_c('BaseBadge',{staticClass:"primary outline"},[_vm._v("Aulas grátis disponíveis!")])],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }